import { createContext, Dispatch, SetStateAction } from 'react';

type AlternativeHeaderState =
  | {
      showAlertNativeHeader: true;
      alternativeHeaderContent: JSX.Element | null;
    }
  | {
      showAlertNativeHeader: false;
      alternativeHeaderContent: null;
    };

export type NavigationContext = {
  setShowAlternativeHeader: Dispatch<SetStateAction<AlternativeHeaderState>>;
};

export const NavigationContext = createContext<NavigationContext | undefined>(
  undefined
);

export const NavigationProvider = NavigationContext.Provider;
